import { render, staticRenderFns } from "./vacancy.vue?vue&type=template&id=4d4b0b2a&scoped=true&"
import script from "./vacancy.vue?vue&type=script&lang=ts&"
export * from "./vacancy.vue?vue&type=script&lang=ts&"
import style0 from "./vacancy.vue?vue&type=style&index=0&id=4d4b0b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b0b2a",
  null
  
)

export default component.exports